import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('@/views/Home.vue'),
    meta: { title: '首页' }
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/Login.vue'),
    meta: { title: '登录' }
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import('@/views/Register.vue'),
    meta: { title: '注册' }
  },
  {
    path: '/pending-welcome',
    name: 'PendingWelcome',
    component: () => import('@/views/PendingWelcome.vue'),
    meta: { title: '等待审批' }
  },
  {
    path: '/forgot-password',
    name: 'ForgotPassword',
    component: () => import('@/views/ForgotPassword.vue'),
    meta: { title: '找回密码' }
  },
  {
    path: '/reset-password',
    name: 'ResetPassword',
    component: () => import('@/views/ResetPassword.vue'),
    meta: { title: '重置密码' }
  },
  {
    path: '/models',
    name: 'Models',
    component: () => import('@/views/models/Index.vue'),
    meta: { title: '模型列表', requiresAuth: true }
  },
  {
    path: '/models/upload',
    name: 'ModelUpload',
    component: () => import('@/views/models/Upload.vue'),
    meta: { title: '上传模型', requiresAuth: true, requiredRole: 'designer' }
  },
  {
    path: '/models/:id/edit',
    name: 'ModelEdit',
    component: () => import('@/views/models/Edit.vue'),
    meta: { title: '编辑模型', requiresAuth: true, requiredRole: 'designer' }
  },
  {
    path: '/models/:id',
    name: 'ModelDetail',
    component: () => import('@/views/models/Detail.vue'),
    meta: { title: '模型详情', requiresAuth: true }
  },
  {
    path: '/profile',
    name: 'Profile',
    component: () => import('@/views/user/Profile.vue'),
    meta: { title: '个人中心', requiresAuth: true }
  },
  {
    path: '/admin',
    name: 'Admin',
    component: () => import('@/views/admin/Index.vue'),
    meta: { title: '管理后台', requiresAdmin: true },
    redirect: '/admin/dashboard',
    children: [
      {
        path: 'dashboard',
        name: 'AdminDashboard',
        component: () => import('@/views/admin/Dashboard.vue'),
        meta: { title: '仪表板' }
      },
      {
        path: 'users',
        name: 'AdminUsers',
        component: () => import('@/views/admin/Users.vue'),
        meta: { title: '用户管理', requiredRole: 'super_admin' }
      },
      {
        path: 'models',
        name: 'AdminModels',
        component: () => import('@/views/admin/Models.vue'),
        meta: { title: '模型管理' }
      },
      {
        path: 'orders',
        name: 'OrderModels',
        component: () => import('@/views/orders/Index.vue'),
        meta: { title: '订单管理系统' }
      },
      {
        path: 'orders/upload',
        name: 'OrderModelUpload',
        component: () => import('@/views/orders/Upload.vue'),
        meta: { title: '上传订单模型' }
      },
      {
        path: 'orders/:id/edit',
        name: 'OrderModelEdit',
        component: () => import('@/views/orders/Edit.vue'),
        meta: { title: '编辑订单模型' }
      },
      {
        path: 'orders/:id',
        name: 'OrderModelDetail',
        component: () => import('@/views/orders/Detail.vue'),
        meta: { title: '订单模型详情' }
      },
      {
        path: 'logs',
        name: 'AdminLogs',
        component: () => import('@/views/admin/Logs.vue'),
        meta: { title: '系统日志', requiredRole: 'super_admin' }
      }
    ]
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: () => import('@/views/NotFound.vue'),
    meta: { title: '页面不存在' }
  }
]

const router = createRouter({
  history: createWebHistory(window.__BASE_PATH__ || '/'),
  routes
})

// 路由守卫
router.beforeEach((to, from, next) => {
  document.title = to.meta.title ? `${to.meta.title} - 3D打印平台` : '3D打印平台'

  const token = localStorage.getItem('token')
  const user = JSON.parse(localStorage.getItem('user') || '{}')

  // 待审批用户：只能访问 pending-welcome 页面
  if (user.role === 'pending' && to.name !== 'PendingWelcome' && to.name !== 'Login' && to.name !== 'Register') {
    next('/pending-welcome')
    return
  }

  // 需要登录的页面
  if (to.meta.requiresAuth && !token) {
    next('/login')
    return
  }

  // 需要管理员权限
  if (to.meta.requiresAdmin && (!token || (user.role !== 'super_admin' && user.role !== 'review_admin'))) {
    next('/')
    return
  }

  const roleLevels = {
    pending: -1,
    visitor: 0,
    designer: 1,
    review_admin: 2,
    super_admin: 3
  }
  if (to.meta.requiredRole && (roleLevels[user.role] ?? -1) < roleLevels[to.meta.requiredRole]) {
    next(token ? '/' : '/login')
    return
  }

  next()
})

export default router
